import { BoMItemRow } from 'model/Project/BoMItemRow'
import { WorkingStepFilter } from 'store/Project/ProjectTypes'
import { showPartTypeBasedOnWorkingSteps } from './showPartTypeBasedOnWorkingSteps'

export function applyWorkingStepFilter(
  filter: WorkingStepFilter,
  row: BoMItemRow
): boolean {
  let workingStepFilterAppliedShowItem = true

  switch (row.type) {
    case 'Row': {
      workingStepFilterAppliedShowItem = showPartTypeBasedOnWorkingSteps(
        row.workingSteps,
        filter
      )
      break
    }
    case 'AssemblyHeader': {
      workingStepFilterAppliedShowItem = showPartTypeBasedOnWorkingSteps(
        row.assembly.assemblyWorkingStepDtos.concat(
          row.assembly.partTypeWorkingStepDtos
        ),
        filter
      )
      break
    }
    case 'Assembly': {
      workingStepFilterAppliedShowItem = showPartTypeBasedOnWorkingSteps(
        row.assemblyWorkingStepDtos.concat(row.partTypeWorkingStepDtos),
        filter
      )
      break
    }
  }

  return workingStepFilterAppliedShowItem
}
